"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/geom/GeometryType
 */

/**
 * The geometry type. One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, `'Circle'`.
 * @enum {string}
 */
var _default = {
  POINT: 'Point',
  LINE_STRING: 'LineString',
  LINEAR_RING: 'LinearRing',
  POLYGON: 'Polygon',
  MULTI_POINT: 'MultiPoint',
  MULTI_LINE_STRING: 'MultiLineString',
  MULTI_POLYGON: 'MultiPolygon',
  GEOMETRY_COLLECTION: 'GeometryCollection',
  CIRCLE: 'Circle'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7OztlQU1lO0VBQ2JBLEtBQUssRUFBRSxPQURNO0VBRWJDLFdBQVcsRUFBRSxZQUZBO0VBR2JDLFdBQVcsRUFBRSxZQUhBO0VBSWJDLE9BQU8sRUFBRSxTQUpJO0VBS2JDLFdBQVcsRUFBRSxZQUxBO0VBTWJDLGlCQUFpQixFQUFFLGlCQU5OO0VBT2JDLGFBQWEsRUFBRSxjQVBGO0VBUWJDLG1CQUFtQixFQUFFLG9CQVJSO0VBU2JDLE1BQU0sRUFBRTtBQVRLLEMiLCJuYW1lcyI6WyJQT0lOVCIsIkxJTkVfU1RSSU5HIiwiTElORUFSX1JJTkciLCJQT0xZR09OIiwiTVVMVElfUE9JTlQiLCJNVUxUSV9MSU5FX1NUUklORyIsIk1VTFRJX1BPTFlHT04iLCJHRU9NRVRSWV9DT0xMRUNUSU9OIiwiQ0lSQ0xFIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9nZW9tL0dlb21ldHJ5VHlwZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==